export default __webpack_public_path__ + "static/media/14.2ff6dbd5.jpeg";